var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncidentReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M11.9865 22.6C9.36771 21.9581 7.21525 20.4964 5.52915 18.2149C3.84305 15.9335 3 13.4308 3 10.707V4.25301L11.9865 1L21 4.25301V10.707C21 13.4308 20.1525 15.9335 18.4574 18.2149C16.7623 20.4964 14.6054 21.9581 11.9865 22.6ZM11.9865 20.466C13.9955 19.772 15.6413 18.5316 16.9238 16.7446C18.2063 14.9576 18.8475 12.9451 18.8475 10.707V5.71036L11.9865 3.21205L5.12556 5.71036V10.707C5.12556 12.9451 5.76682 14.9576 7.04933 16.7446C8.33184 18.5316 9.97758 19.772 11.9865 20.466Z",
    fill: "#605E5C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V6Z",
    fill: "#605E5C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17Z",
    fill: "#605E5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentReporting);
export default __webpack_public_path__ + "static/media/Incident_reporting.a6ef9f2538163eb28a13aa637dcdb6c2.svg";
export { ForwardRef as ReactComponent };